<template>
	<div>
		<v-toolbar
			color="blue"
			dark>
			<v-toolbar-title class="text-xs-center; width=200px;">
				<v-icon color="white">people</v-icon>
				<b style="font-size: 16px"> Oferta wspólna</b>
			</v-toolbar-title>
			<v-layout>
				<v-flex pl-5>
					<v-switch
						v-if="!readonly"
						v-model="localMutualOffer"
						color="white"
						hide-details
						@change="switchChange"
						aria-label="label for switch"
					></v-switch>
				</v-flex>
			</v-layout>
		</v-toolbar>

		<v-expand-transition>
			<v-layout v-show="mutualOffer">
				<v-flex xs12 sm6 d-flex pa-3>
					<v-autocomplete
						v-if="!readonly"
						v-model="selectedBidders"
						:items="availableBidders"
						multiple
						item-text="polishName"
						item-value="id"
						:label="readonly ? 'Współoferenci' : 'Oferenci, z którymi składasz ofertę'"
						aria-label="bidders"
						for="offer-other-bidders-bidders-with"
						id="offer-other-bidders-bidders-with"
						@input="registerBiddersChanged"
						return object
					></v-autocomplete>
					<div v-if="readonly">
						<b class="mr-2">Współoferenci: </b> {{selectedBiddersReadOnlyNames.join(", ")}}
					</div>
				</v-flex>
			</v-layout>
		</v-expand-transition>
		<egranty-validation-error
			:error="error"
		></egranty-validation-error>
	</div>
</template>

<script>
	import {Offer} from "@/api/generated/Offer";
	import EgrantyValidationError from "../../../../genericComponents/EgrantyValidationError";
  import {Bidder} from "@/api/generated/Bidder";

	export default {
		name: "OfferOtherBidders",

		components: {EgrantyValidationError},

		data() {
			return {
        availableBidders: [],
				selectedBidders: [],
        selectedBiddersReadOnlyNames: [],
				localMutualOffer: this.mutualOffer,
				error: "",
			};
		},

		methods: {
			validate() {
				if (this.mutualOffer && this.selectedBidders.length === 0) {
					this.error = "Jeżeli jest to oferta wspólna, to muszą być wybrani współoferenci";
					return false;
				}
				return true;
			},

			switchChange () {
				this.error = "";
				this.selectedBidders = [];
				this.emitBiddersChanged();
			},

			registerBiddersChanged(val) {
				this.$emit("input", val);
				this.emitBiddersChanged();
			},

			emitBiddersChanged () {
				this.$emit("biddersChanged");
			},

      loadReadOnlyMutualBiddersNames() {
        if (this.$route.params.version) {
          this.selectedBidders.forEach(bidderId => {
            Bidder.getOriginalOfferVersionDetails(this, bidderId, this.$route.params.offerId, this.$route.params.version, successResponse => {
              this.selectedBiddersReadOnlyNames.push(successResponse.polishName);
            }, errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się załadować danych oferenta", errorResponse);
            });
          });
        } else {
          this.selectedBidders.forEach(bidderId => {
            Bidder.getOriginalOfferDetails(this, bidderId, this.$route.params.offerId, successResponse => {
              this.selectedBiddersReadOnlyNames.push(successResponse.polishName);
            }, errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się załadować danych oferenta", errorResponse);
            });
          });
        }
      },

      loadAvailableMutualBidders() {
        Offer.getAvailableOfferMutualBidders(this, this.$route.params.offerId, successResponse => {
              this.availableBidders = successResponse;
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się pobrać listy współoferentów", errorResponse);
            }
        );
      }
		},

		mounted() {
      if (this.readonly) {
        this.loadReadOnlyMutualBiddersNames();
      } else {
        this.loadAvailableMutualBidders();
      }
		},

		props: {
			readonly: {
				default: false
			},
			value: Array,
			mutualOffer: Boolean,
		},

		watch: {
			value: {
				immediate: true,
				handler (val) {
					this.selectedBidders = val;
				},
			},

			localMutualOffer: {
				handler (val) {
					this.$emit("change", val);
				},
			},
		},
	};
</script>

<style scoped>
  >>> .v-toolbar__content {
    padding: 0 8px;
  }
</style>
